var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"work-space"},[_c('SideBar',{attrs:{"sections":_vm.sections},on:{"launch-app":_vm.launchApp}}),_c('WebContent',{attrs:{"url":_vm.url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }